
export const SUBSCRIPTION_STATUS_FREE = 'FREE';
export const SUBSCRIPTION_STATUS_ACTIVE = 'ACTIVE';
export const SUBSCRIPTION_STATUS_CANCELED = 'CANCELED';
export const SUBSCRIPTION_STATUS_UNSUBSCRIBED = 'UNSUBSCRIBED';
